<template>
  <div class="mj_page flex jb">
    <div class="left_area">
      <div class="left_top">

        <router-link :to="relation==3?'/aiBeautify':'/aiTool'">
          <div class="goBack">
            <div class="iconFont">
              <div>
                <img src="./img/back.png" alt="">
              </div>
              返回
            </div>
            <div class="font_title">
              {{ relation == 3 ? 'AI变美' : '工具箱' }} - {{ toolList[relation].list[arrange - 1].name }}
            </div>
          </div>
        </router-link>
        <div class="top_img">
          <img :src="toolList[relation].list[arrange - 1].img" alt="">
        </div>

        <!--组件-->
        <!--  图片编辑  -->
        <lossless ref="lossless" v-if="arrange==='1'&&relation==='0'"></lossless>
        <imgremoval ref="imgremoval" @drowMask="drow_mask" v-if="arrange==='2'&&relation==='0'"></imgremoval>
        <bestquality ref="bestquality" v-if="arrange==='3'&&relation==='0'"></bestquality>
        <sharpness ref="sharpness" v-if="arrange==='4'&&relation==='0'"></sharpness>
        <painting ref="painting" v-if="arrange==='5'&&relation==='0'"></painting>

        <!--  电商设计  -->
        <bgremoval ref="bgremoval" v-if="arrange==='1'&&relation==='1'"></bgremoval>
        <tryonclothes ref="tryonclothes" v-if="arrange==='2'&&relation==='1'"></tryonclothes>

        <!--  创意应用  -->
        <HeadExtraction ref="headextraction" v-if="arrange==='1'&&relation==='2'"></HeadExtraction>

        <!-- ai变美 -->
        <!--  一键变美  -->
        <oneClickBeautyTransformation ref="oneClickBeautyTransformation"
                                      v-if="arrange==='1'&&relation==='3'"></oneClickBeautyTransformation>
        <!--  动漫化  -->
        <characterAnime ref="characterAnime" v-if="arrange==='2'&&relation==='3'"></characterAnime>
        <!--  人脸滤镜修复  -->
        <emitFacefilter ref="emitFacefilter" v-if="arrange==='3'&&relation==='3'"></emitFacefilter>
        <!--  人脸模糊（打码）  -->
        <emitBlurredfaces ref="emitBlurredfaces" v-if="arrange==='4'&&relation==='3'"></emitBlurredfaces>
        <!--  发型编辑  -->
        <emitHairstyleeditor ref="emitHairstyleeditor" v-if="arrange==='5'&&relation==='3'"></emitHairstyleeditor>
        <!--  表情编辑  -->
        <emitEmotioneditor ref="emitEmotioneditor" v-if="arrange==='6'&&relation==='3'"></emitEmotioneditor>
        <!--  年龄・性別变换  -->
        <emitFaceattributeediting ref="emitFaceattributeediting"
                                  v-if="arrange==='7'&&relation==='3'"></emitFaceattributeediting>
        <!--  人脸美颜  -->
        <emitFacebeauty ref="emitFacebeauty" v-if="arrange==='8'&&relation==='3'"></emitFacebeauty>

        <!--  人脸美妆  -->
        <emitFacemakeup ref="emitFacemakeup" v-if="arrange==='9'&&relation==='3'"></emitFacemakeup>

        <!--  唇色变换器  -->
        <emitLipscolorchanger ref="emitLipscolorchanger" v-if="arrange==='10'&&relation==='3'"></emitLipscolorchanger>
        <!--  人脸修复增强  -->
        <emitEnhanceface ref="emitEnhanceface" v-if="arrange==='11'&&relation==='3'"></emitEnhanceface>

      </div>

      <div class="createButton">
        <div class="createBtn" @click="sendMsg()" v-loading="sending">
          提交任务 <span>（消耗{{ toolList[relation].list[arrange - 1].points }}积分）</span>
        </div>
        <div class="screen">
          内容由 Ai 生成，请仔细甄别
        </div>
      </div>
    </div>

    <div class="draw_area">
      <div class="draw_area_tips">
        <span class="one">#</span><span class="two">创作中心</span><span class="three">请遵守中华人民共和国网络安全法， 严禁生成涉及政治人物，色情、恐怖等不良内容， 如有违规封号处理</span>
      </div>
      <!--登录前-->
      <!--样例数据开始-->
      <div class="draw_scroll"
           ref="scrollWrap" @scroll="testScroll">
        <div class="draw_list"
             v-if="!isLogin||draw_list.length==0">
          <div class="draw_list_item flex jb"
               v-for="(item,index) in sampleSysList"
               :key="index">
            <!--            <img alt="" src="./img/dallE3/dall_log1.png"-->
            <!--                 class="avatar"/>-->
            <div class="avatar">
              <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="40" height="40">
                <path d="M536.508695 515.037173 533.082666 506.909052 528.910647 510.318708Z" fill="#FFFFFF"
                      p-id="1904"></path>
                <path
                    d="M431.339424 549.69553 194.782753 549.69553c-21.871123 0-39.666418 17.796318-39.666418 39.667441l0 236.553601c0 21.87317 17.795295 39.667441 39.666418 39.667441l236.556671 0c21.871123 0 39.665395-17.794271 39.665395-39.667441L471.004819 589.362972C471.004819 567.491849 453.210547 549.69553 431.339424 549.69553zM430.205601 824.780703 195.9176 824.780703 195.9176 590.497818l234.288001 0L430.205601 824.780703z"
                    fill="#252135" p-id="1905"></path>
                <path
                    d="M192.211185 508.24242l236.557694 0c21.871123 0 39.665395-17.794271 39.665395-39.664372l0-236.557694c0-21.871123-17.794271-39.664372-39.665395-39.664372L192.211185 192.355983c-21.871123 0-39.664372 17.793248-39.664372 39.664372l0 236.557694C152.547837 490.448148 170.340061 508.24242 192.211185 508.24242zM193.349101 233.155201l234.284931 0 0 234.285954L193.349101 467.441155 193.349101 233.155201z"
                    fill="#252135" p-id="1906"></path>
                <path
                    d="M813.097104 547.127032 576.541457 547.127032c-21.862937 0-39.646975 17.794271-39.646975 39.665395l0 236.555647c0 21.871123 17.784038 39.665395 39.646975 39.665395l236.555647 0c21.881356 0 39.683814-17.794271 39.683814-39.665395L852.780919 586.792427C852.780919 564.921303 834.978461 547.127032 813.097104 547.127032zM811.980677 822.213227 577.69677 822.213227 577.69677 587.927273l234.283908 0L811.980677 822.213227z"
                    fill="#252135" p-id="1907"></path>
                <path
                    d="M859.52553 314.327942 720.943264 175.745676c-7.087419-7.064906-16.504906-10.956539-26.51591-10.956539-10.008958 0-19.422352 3.891633-26.5374 10.981099L529.377274 314.303382c-7.110955 7.089465-11.026124 16.522302-11.026124 26.561959s3.91517 19.473517 11.000542 26.536376l138.539286 138.559752c7.080256 7.080256 16.501836 10.980076 26.529213 10.980076 10.016121 0 19.436678-3.891633 26.547633-10.980076L859.550089 367.380228C874.147552 352.73774 874.136296 328.939731 859.52553 314.327942zM694.429401 471.41363 563.900555 340.865341 694.429401 210.318076l130.547265 130.547265L694.429401 471.41363z"
                    fill="#252135" p-id="1908"></path>
                <path
                    d="M432.577624 550.656415 195.628004 550.656415c-21.911032 0-39.737026 17.825994-39.737026 39.739073l0 236.947574c0 21.908986 17.825994 39.730886 39.737026 39.730886l236.94962 0c21.906939 0 39.729863-17.821901 39.729863-39.730886L472.307488 590.395488C472.307488 568.482409 454.484563 550.656415 432.577624 550.656415z"
                    fill="#262236" p-id="1909"></path>
                <path
                    d="M193.054389 509.131673 429.996846 509.131673c21.911032 0 39.737026-17.823947 39.737026-39.729863L469.733872 232.452189c0-21.905916-17.824971-39.729863-39.737026-39.729863L193.054389 192.722326c-21.911032 0-39.73805 17.823947-39.73805 39.729863l0 236.94962C153.317363 491.307725 171.143357 509.131673 193.054389 509.131673z"
                    fill="#262236" p-id="1910"></path>
                <path
                    d="M814.956452 548.084846 578.007855 548.084846c-21.894659 0-39.709397 17.825994-39.709397 39.737026l0 236.941434c0 21.911032 17.813714 39.737026 39.709397 39.737026l236.948597 0c21.919219 0 39.752376-17.825994 39.752376-39.737026L854.708827 587.821873C854.707804 565.91084 836.874647 548.084846 814.956452 548.084846z"
                    fill="#262236" p-id="1911"></path>
                <path
                    d="M861.463672 314.897923 722.654232 176.09667c-7.098675-7.082302-16.533558-10.983145-26.565029-10.983145-10.027377 0-19.461237 3.900843-26.578332 11.002588L530.769994 314.871317c-7.124258 7.099698-11.047614 16.548908-11.047614 26.606984 0 10.060123 3.923356 19.508309 11.019984 26.579355l138.770554 138.79409c7.092535 7.092535 16.529465 10.998495 26.573215 10.998495 10.037611 0 19.472494-3.900843 26.587542-10.998495l138.817626-138.818649C876.107183 353.365027 876.095927 329.529155 861.463672 314.897923zM696.092273 472.244554 565.348534 341.478302l130.744763-130.757043 130.765229 130.757043L696.092273 472.244554z"
                    fill="#262236" p-id="1912"></path>
                <path d="M537.607726 518.65149 534.18272 510.522346 530.009677 513.932002Z" fill="#FFFFFF"
                      p-id="1913"></path>
              </svg>
            </div>
            <div class="text">
              <div class="title flex jb ac">
                <p class="info flex ac">
                  <span class="name">工具箱</span>
                  <span class="tag">
                    {{ toolList[relation].list[arrange - 1].name }}
                  </span>
                  <span class="time">
                    {{ item.add_time }}
                  </span>
                </p>
                <div class="flex ac">
                  <p class="delete flex ac"
                     @click="sampleDeleteDraw(item, index)">
                    <img alt="" src="./img/delete.svg"/>
                    <span>删除</span></p>
                </div>
              </div>
              <div class="desc">
                <!--                <p class="zh">{{ item.prompt }}</p>-->
              </div>
              <div>
                <div class="big_img">
                  <div class="msg_img_sample" v-if="relation<3">
                    <el-image style="display:block;"
                              @click.prevent="clickImage(item.id,'sample')"
                              :src="item.img_url"
                              :preview-src-list="[item.img_url ]">
                    </el-image>
                  </div>
                  <div class="big_img" v-if="relation==3">
                    <div class="msg_img_wrap">
                      <el-image style="display:block;max-width: 400px;"
                                :src=" item.iw_url "
                                :preview-src-list="[item.iw_url ]">
                      </el-image>
                      <div class="left_img"><span>处理前</span></div>
                    </div>
                    <div class="arrow_icon">
                      <div>
                        <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="10"
                             height="10">
                          <path
                              d="M276.755 942.936c28.497 29.315 74.739 29.315 103.307 0l367.236-378.011c28.483-29.367 28.483-76.982 0-106.291l-367.236-377.997c-28.562-29.367-74.806-29.367-103.307 0-28.546 29.325-28.546 76.929 0 106.304l315.6 324.841-315.599 324.803c-28.545 29.367-28.544 76.973 0 106.356l0 0z"
                              fill="#6e7173"></path>
                        </svg>
                      </div>
                    </div>
                    <div class="msg_img_wrap"
                         :class="toolList[relation].list[arrange - 1].mj_tool!='HeadExtraction'?'msg_img_width1':'msg_img_width2'">
                      <el-image style="display:block;max-width: 100%;height: auto;"
                                :src="item.img_url"
                                :preview-src-list="[item.img_url ]">
                      </el-image>
                      <div @click.stop="ImageJump(item.img_url,item.s_w,item.s_h)" class="look_img">
                        {{ toolList[relation].list[arrange - 1].mj_tool != 'HeadExtraction' ? '查看原图' : '查看' }}
                      </div>
                      <div class="right_img"><span>处理后</span></div>
                    </div>
                  </div>
                  <div class="tozan">
                    <div class="zanOne" @click="tozanFn(item,index)" v-show="!item.is_vote">
                      <img src="./img/zan1.png" class="zanImg"/> 赞一下
                    </div>
                    <div class="zanDetail" v-show="item.is_vote">
                      <div class="zanOne zanTwo">
                        <img src="./img/zan2.png" class="zanImg"/> 已赞过
                      </div>
                    </div>
                    <div class="zanTex">
                      此作品已获得{{ item.vote }}个赞
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--样例数据结束-->
        <!-- </div>
    <div class="draw_scroll"> -->
        <!--        登录过后-->
        <div class="draw_list" v-infinite-scroll="loadMore"
             :infinite-scroll-immediate="false"
             :infinite-scroll-disabled="noMore || loading">
          <div class="draw_list_item flex jb"
               v-for="(item,index) in draw_list"
               :key="index">
            <div class="avatar">
              <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="40" height="40">
                <path d="M536.508695 515.037173 533.082666 506.909052 528.910647 510.318708Z" fill="#FFFFFF"
                      p-id="1904"></path>
                <path
                    d="M431.339424 549.69553 194.782753 549.69553c-21.871123 0-39.666418 17.796318-39.666418 39.667441l0 236.553601c0 21.87317 17.795295 39.667441 39.666418 39.667441l236.556671 0c21.871123 0 39.665395-17.794271 39.665395-39.667441L471.004819 589.362972C471.004819 567.491849 453.210547 549.69553 431.339424 549.69553zM430.205601 824.780703 195.9176 824.780703 195.9176 590.497818l234.288001 0L430.205601 824.780703z"
                    fill="#252135" p-id="1905"></path>
                <path
                    d="M192.211185 508.24242l236.557694 0c21.871123 0 39.665395-17.794271 39.665395-39.664372l0-236.557694c0-21.871123-17.794271-39.664372-39.665395-39.664372L192.211185 192.355983c-21.871123 0-39.664372 17.793248-39.664372 39.664372l0 236.557694C152.547837 490.448148 170.340061 508.24242 192.211185 508.24242zM193.349101 233.155201l234.284931 0 0 234.285954L193.349101 467.441155 193.349101 233.155201z"
                    fill="#252135" p-id="1906"></path>
                <path
                    d="M813.097104 547.127032 576.541457 547.127032c-21.862937 0-39.646975 17.794271-39.646975 39.665395l0 236.555647c0 21.871123 17.784038 39.665395 39.646975 39.665395l236.555647 0c21.881356 0 39.683814-17.794271 39.683814-39.665395L852.780919 586.792427C852.780919 564.921303 834.978461 547.127032 813.097104 547.127032zM811.980677 822.213227 577.69677 822.213227 577.69677 587.927273l234.283908 0L811.980677 822.213227z"
                    fill="#252135" p-id="1907"></path>
                <path
                    d="M859.52553 314.327942 720.943264 175.745676c-7.087419-7.064906-16.504906-10.956539-26.51591-10.956539-10.008958 0-19.422352 3.891633-26.5374 10.981099L529.377274 314.303382c-7.110955 7.089465-11.026124 16.522302-11.026124 26.561959s3.91517 19.473517 11.000542 26.536376l138.539286 138.559752c7.080256 7.080256 16.501836 10.980076 26.529213 10.980076 10.016121 0 19.436678-3.891633 26.547633-10.980076L859.550089 367.380228C874.147552 352.73774 874.136296 328.939731 859.52553 314.327942zM694.429401 471.41363 563.900555 340.865341 694.429401 210.318076l130.547265 130.547265L694.429401 471.41363z"
                    fill="#252135" p-id="1908"></path>
                <path
                    d="M432.577624 550.656415 195.628004 550.656415c-21.911032 0-39.737026 17.825994-39.737026 39.739073l0 236.947574c0 21.908986 17.825994 39.730886 39.737026 39.730886l236.94962 0c21.906939 0 39.729863-17.821901 39.729863-39.730886L472.307488 590.395488C472.307488 568.482409 454.484563 550.656415 432.577624 550.656415z"
                    fill="#262236" p-id="1909"></path>
                <path
                    d="M193.054389 509.131673 429.996846 509.131673c21.911032 0 39.737026-17.823947 39.737026-39.729863L469.733872 232.452189c0-21.905916-17.824971-39.729863-39.737026-39.729863L193.054389 192.722326c-21.911032 0-39.73805 17.823947-39.73805 39.729863l0 236.94962C153.317363 491.307725 171.143357 509.131673 193.054389 509.131673z"
                    fill="#262236" p-id="1910"></path>
                <path
                    d="M814.956452 548.084846 578.007855 548.084846c-21.894659 0-39.709397 17.825994-39.709397 39.737026l0 236.941434c0 21.911032 17.813714 39.737026 39.709397 39.737026l236.948597 0c21.919219 0 39.752376-17.825994 39.752376-39.737026L854.708827 587.821873C854.707804 565.91084 836.874647 548.084846 814.956452 548.084846z"
                    fill="#262236" p-id="1911"></path>
                <path
                    d="M861.463672 314.897923 722.654232 176.09667c-7.098675-7.082302-16.533558-10.983145-26.565029-10.983145-10.027377 0-19.461237 3.900843-26.578332 11.002588L530.769994 314.871317c-7.124258 7.099698-11.047614 16.548908-11.047614 26.606984 0 10.060123 3.923356 19.508309 11.019984 26.579355l138.770554 138.79409c7.092535 7.092535 16.529465 10.998495 26.573215 10.998495 10.037611 0 19.472494-3.900843 26.587542-10.998495l138.817626-138.818649C876.107183 353.365027 876.095927 329.529155 861.463672 314.897923zM696.092273 472.244554 565.348534 341.478302l130.744763-130.757043 130.765229 130.757043L696.092273 472.244554z"
                    fill="#262236" p-id="1912"></path>
                <path d="M537.607726 518.65149 534.18272 510.522346 530.009677 513.932002Z" fill="#FFFFFF"
                      p-id="1913"></path>
              </svg>
            </div>
            <div class="text">
              <div class="title flex jb ac">
                <p class="info flex ac">
                  <span class="name">工具箱</span>
                  <span class="tag">
                    {{ toolList[relation].list[arrange - 1].name }}
                  </span>
                  <span class="time">
                    {{ item.add_time }}
                  </span>

                </p>
                <div class="flex ac">
                  <p class="delete flex ac"
                     @click="delete_draw_list(item.draw_id, index)">
                    <img alt="" src="./img/delete.svg"/><span>删除</span>
                  </p>
                  <div style="margin-left: 5px;cursor: pointer;" @click="downloadVideo( item)">
                    <i class="el-icon-download" style="font-size: 14px;"></i>下载
                  </div>
                </div>
              </div>
              <div class="desc">
              </div>
              <div class="create_error"
                   v-if="item.status == 3">
                <img class="error_icon"
                     src="./img/image_error.png"
                     alt="">
                <div class="error_text">很遗憾，绘画失败 !</div>
                <div class="error_btn" @click="showDefeatPopup">查看失败原因</div>
                <div class="error_text4" v-if="item.show_error">
                  失败原因： <span style="color:red;">{{item.show_error}}</span>
                </div>
                <div class="error_text4" v-else>涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                    @click="utils.openKefu()"
                    target="_blank">在线客服</a></div>
              </div>
              <template v-else-if="item.status < 2">
                <div class="detail_loading msg-item-content">
                  <circleloading></circleloading>
                  <div class="loading_text">正在全力出图中，请稍等...
                  </div>
                </div>
                <!-- <div class="creating_progress"v-if="item.progress > 0">
                  <div class="progress_bar">
                    <div class="progress_line" :style="{'width':item.progress+'%'}"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div> -->
              </template>
              <div v-else>
                <div class="tryonImg" v-if="item.img_type=='imgVirtualTryOn'">
                  <div class="modelImg">
                    <el-image
                        :src="item.iw_url"
                        :preview-src-list="[item.iw_url]"
                        fit="cover"
                    >
                    </el-image>
                  </div>
                  <div class="addImg">
                    <img src="./img/clJia.png" alt="">
                  </div>
                  <div class="modelImg">
                    <el-image
                        :src="item.iw_urls||JSON.parse(item.parameters).iw_urls"
                        :preview-src-list="[JSON.parse(item.parameters).iw_urls]"
                        fit="cover"
                    >
                    </el-image>
                  </div>
                  <div class="addImg">
                    <img src="./img/clDeng.png" alt="">
                  </div>
                  <div class="modelImg">
                    <el-image
                        :src="item.img_url"
                        :preview-src-list="[item.img_url]"
                        fit="cover"
                    >
                    </el-image>
                  </div>
                </div>
                <div class="big_img" v-if="item.img_url && item.progress==100&&item.img_type!='imgVirtualTryOn'">
                  <div class="msg_img_wrap">
                    <el-image style="display:block;max-width: 400px;"
                              :src=" item.iw_small_url "
                              :preview-src-list="[item.iw_url ]">
                    </el-image>
                    <div class="left_img"><span>处理前</span></div>
                  </div>
                  <div class="arrow_icon"
                       v-if="toolList[relation].list[arrange - 1].mj_tool!='HeadExtraction'&&toolList[relation].list[arrange - 1].mj_tool!='BackgroundRemoval'">
                    <div>
                      <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="10"
                           height="10">
                        <path
                            d="M276.755 942.936c28.497 29.315 74.739 29.315 103.307 0l367.236-378.011c28.483-29.367 28.483-76.982 0-106.291l-367.236-377.997c-28.562-29.367-74.806-29.367-103.307 0-28.546 29.325-28.546 76.929 0 106.304l315.6 324.841-315.599 324.803c-28.545 29.367-28.544 76.973 0 106.356l0 0z"
                            fill="#6e7173"></path>
                      </svg>
                    </div>
                  </div>
                  <div class="arrow_icon2" v-else>
                    <div>
                      <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="10"
                           height="10">
                        <path
                            d="M233.046 941.461c-18.88 17.846-18.88 46.715 0.105 64.48 18.985 17.84 49.622 17.84 68.607 0l489.848-460.275c9.568-8.87 14.149-20.597 14.149-32.273 0-0.99-0.523-1.82-0.575-2.758-0.21-4.887-0.99-9.782-2.966-14.356-0.674-1.513-1.976-2.604-2.807-4.005-2.186-3.849-4.371-7.806-7.801-11.134L301.759 20.79c-18.985-17.631-49.517-17.631-68.607 0.053-18.985 17.788-18.985 46.71 0 64.5L688.608 513.39l-455.562 428.07z m0 0"
                            fill="#ffffff" p-id="2576"></path>
                      </svg>
                    </div>
                  </div>
                  <div class="msg_img_wrap"
                       :class="toolList[relation].list[arrange - 1].mj_tool!='HeadExtraction'?'msg_img_width1':'msg_img_width2'">
                    <el-image style="display:block;max-width: 100%;height: auto;"
                              :src="item.img_url"
                              :preview-src-list="[item.img_url ]">
                    </el-image>
                    <div @click.stop="ImageJump(item.img_url ,item.s_w,item.s_h)" class="look_img">
                      {{ toolList[relation].list[arrange - 1].mj_tool != 'HeadExtraction' ? '查看原图' : '查看' }}
                    </div>
                    <div class="right_img"><span>处理后</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 实名认证 -->
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
    <popup ref="defeatPopup" type="center" @close="defeatPopClose">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_item">
            <div class="item_question">问：为什么MJ绘画出图会比较慢？</div>
            <div class="item_answer">
              答：因为MJ绘画与其他绘画软件不同，一次性生成四张高清图片，通常仅需约5分钟完成，算下来速度相当快！
            </div>
          </div>
          <div class="content_item">
            <div class="item_question">问：为什么绘画会提示失败？</div>
            <div class="item_answer">
              答：因为MJ绘画全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除，与您无关！
            </div>
          </div>
        </div>
        <button class="close_btn" @click="defeatPopClose">好的，我知道了</button>
      </div>
    </popup>
  </div>
</template>

<script>
import popup from "COMPONENTS/Popup.vue"
import circleloading from "COMPONENTS/CircleLoading.vue"
import lossless from "COMPONENTS/ToolChild/lossless.vue";
import imgremoval from "COMPONENTS/ToolChild/imgremoval.vue";
import bestquality from "COMPONENTS/ToolChild/bestquality.vue";
import sharpness from "COMPONENTS/ToolChild/sharpness.vue";
import painting from "COMPONENTS/ToolChild/painting.vue";
import bgremoval from "COMPONENTS/ToolChild/bgremoval.vue";
import tryonclothes from "COMPONENTS/ToolChild/tryonclothes.vue";
import HeadExtraction from "COMPONENTS/ToolChild/HeadExtraction.vue";
import oneClickBeautyTransformation from "COMPONENTS/ToolChild/oneClickBeautyTransformation.vue";
import characterAnime from "COMPONENTS/ToolChild/characterAnime.vue";
import emitFacefilter from "COMPONENTS/ToolChild/emitFacefilter.vue";
import emitBlurredfaces from "COMPONENTS/ToolChild/emitBlurredfaces.vue";
import emitHairstyleeditor from "COMPONENTS/ToolChild/emitHairstyleeditor.vue";
import emitEmotioneditor from "COMPONENTS/ToolChild/emitEmotioneditor.vue";
import emitFaceattributeediting from "COMPONENTS/ToolChild/emitFaceattributeediting.vue";
import emitFacebeauty from "COMPONENTS/ToolChild/emitFacebeauty.vue";
import emitFacemakeup from "COMPONENTS/ToolChild/emitFacemakeup.vue";
import emitLipscolorchanger from "COMPONENTS/ToolChild/emitLipscolorchanger.vue";
import emitEnhanceface from "COMPONENTS/ToolChild/emitEnhanceface.vue";

// 实名
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu"
import utils from '../utils/index.js'


export default {
  components: {
    popup,
    circleloading,
    lossless,
    imgremoval,
    bestquality,
    sharpness,
    painting,
    bgremoval,
    tryonclothes,
    HeadExtraction,
    oneClickBeautyTransformation,
    characterAnime,
    emitFacefilter,
    emitBlurredfaces,
    emitHairstyleeditor,
    emitEmotioneditor,
    emitFaceattributeediting,
    emitFacebeauty,
    emitFacemakeup,
    emitLipscolorchanger,
    emitEnhanceface,
    faceVerifyPopup,

  },
  data() {
    return {
      // kefu_url:SITE_BTN_CONFIG.kefu_url.btn_value,
      //显示个人中心
      show_person_hover: false,
      //显示用户反馈
      show_feedback_popup: false,
      //显示推荐到广场
      show_recommend_popup: false,
      //显示分享弹窗
      show_sharedraw_popup: false,

      draw_list: [],
      sending: false, // 提交绘画状态
      noMore: false, // 是否还有数据
      loading: false, // 正在请求数据
      max_mj_id: 0, // 最小的ID
      checkIds: [], // 生成中的需要检测的ID
      timer: null,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例

      sampleTimer: null,
      // 提交参数
      form: {
        mj_tool: ""
      },
      // 上传图片
      fileApi: FILE_API_SERVER,
      page: 1,
      pageType: false,
      currentTimer: new Date(),
      liveAlone: '',
      arrange: '',
      relation: '',
      toolList: [
        {
          title: '图片编辑', list: [
            {
              id: 1,
              relation: 0,
              name: '极速高清无损放大',
              mj_tool: 'Upscaler',
              guide: '图片放大不失真',
              img: require('./img/aiTool/magnify.webp'),
              points: 6,
            },
            {
              relation: 0,
              name: '图像擦除',
              mj_tool: 'imgRemove',
              guide: '快速移除照片中不需要的的物、人、文字。清理照片，美化图片',
              img: require('./img/aiTool/remove.webp'),
              id: 2,
              points: 6,
            },
            {
              id: 3,
              relation: 0,
              name: '黑白图像上色',
              mj_tool: 'Colorize',
              guide: '黑白照片一键上色变清晰',
              img: require('./img/aiTool/colour.webp'),
              points: 2,
            },
            {
              id: 4,
              relation: 0,
              name: '图像清晰度增强',
              mj_tool: 'SharpnessEnhancement',
              guide: '智能修复模糊照片，一键模糊图片变清晰',
              img: require('./img/aiTool/repair.webp'),
              points: 2,
            },
            {
              id: 5,
              relation: 0,
              name: '图像风格转换',
              mj_tool: 'Painting',
              guide: '通过人工智能算法，识别黑白图像内容并填充色彩，使黑白图像变得鲜活。',
              img: require('./img/aiTool/cartoon.webp'),
              points: 8,
            },

          ],
        },
        {
          title: '电商设计', list: [
            {
              id: 1,
              relation: 1,
              name: '背景移除  ',
              mj_tool: 'BackgroundRemoval',
              guide: '一键智能扩图，也可以对图片进行上下左右自定义像素的自动填充',
              img: require('./img/aiTool/capture.webp'),
              points: 1,
            },
            {
              id: 2,
              relation: 1,
              name: 'AI虚拟试衣  ',
              mj_tool: 'imgVirtualTryOn',
              guide: '一键智能扩图，也可以对图片进行上下左右自定义像素的自动填充',
              img: require('./img/aiTool/fittingRoom.webp'),
              points: 15,
            },

          ],
        },
        {
          title: '创意应用', id: 3, list: [
            {
              id: 1,
              relation: 2,
              name: '头像提取',
              mj_tool: 'HeadExtraction',
              guide: '一键智能扩图，也可以对图片进行上下左右自定义像素的自动填充',
              img: require('./img/aiTool/expansion.webp'),
              points: 1,
            },

          ],
        },
        {
          title: 'ai美颜', id: 4, list: [
            {
              id: 1,
              relation: 3,
              name: '照片一键美颜',
              mj_tool: 'oneClickBeautyTransformation',
              guide: '利用AI技术，实现完整的肖像增强，包括皮肤平滑、美白、脸部瘦身等，以达到自然的外观',
              img: require('../components/img/side/beautify1.webp'),
              points: 10,
            },
            {
              id: 2,
              relation: 3,
              name: '人物动漫化',
              mj_tool: 'characterAnime',
              guide: '利用先进的AI技术将完整图像或照片转化为卡通或动漫效果，非常适合创建卡通化照片和卡通风格的虚拟形象',
              img: require('../components/img/side/beautify2.webp'),
              points: 20,
            },
            {
              id: 3,
              relation: 3,
              name: '人脸滤镜',
              mj_tool: 'emitFacefilter',
              guide: '智能识别图像内容，快速应用AI滤镜，提升图像质感，支持滤镜强度调节，轻松优化视觉效果',
              img: require('../components/img/side/beautify3.webp'),
              points: 2,
            },
            {
              id: 4,
              relation: 3,
              name: '人脸模糊(打码)',
              mj_tool: 'emitBlurredfaces',
              guide: '利用先进的AI技术，智能识别人脸区域，一键模糊人脸，轻松保护隐私，提升图像安全性',
              img: require('../components/img/side/beautify4.webp'),
              points: 2,
            },
            {
              id: 5,
              relation: 3,
              name: '发型编辑',
              mj_tool: 'emitHairstyleeditor',
              guide: '能够精准识别人像区域，实现一键更换发型和发色。您可以选择多达数十种发型和发色组合，轻松打造您独特的个性化造型，满足不同的美发需求',
              img: require('../components/img/side/beautify5.webp'),
              points: 10,
            },
            {
              id: 6,
              relation: 3,
              name: '表情编辑',
              mj_tool: 'emitEmotioneditor',
              guide: '无论是闭嘴微笑、露齿笑、嘟嘴、还是耍酷或悲伤等十多种表情，您都可以轻松生成自然逼真的效果',
              img: require('../components/img/side/beautify6.webp'),
              points: 15,
            },
            {
              id: 7,
              relation: 3,
              name: '年龄・性別变换',
              mj_tool: 'emitFaceattributeediting',
              guide: '采用先进的AI技术，智能识别人脸，实现从15岁到85岁的年龄变换，以及男性与女性之间的性别转换',
              img: require('../components/img/side/beautify7.webp'),
              points: 10,
            },
            {
              id: 8,
              relation: 3,
              name: '人脸美颜',
              mj_tool: 'emitFacebeauty',
              guide: '采用先进的AI技术，智能识别人脸，实现从1岁到85岁的年龄变换，以及男性与女性之间的性别转换',
              img: require('../components/img/side/beautify8.webp'),
              points: 15,
            },
            {
              id: 9,
              relation: 3,
              name: '人脸美妆',
              mj_tool: 'emitFacemakeup',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../components/img/side/beautify9.webp'),
              points: 5,
            },
            {
              id: 10,
              relation: 3,
              name: '唇色变换器',
              mj_tool: 'emitLipscolorchanger',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('../components/img/side/beautify10.webp'),
              points: 2,
            },
            {
              id: 11,
              relation: 3,
              name: '人脸修复增强',
              mj_tool: 'emitEnhanceface',
              guide: '自动去除图像中的模糊部分，提升脸部的清晰度和细节。通过AI处理，您可以轻松优化面部图像的质量，使其更加清晰、自然',
              img: require('../components/img/side/beautify11.webp'),
              points: 15,
            },
          ],
        },

      ],
      imagePairs: [],
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    is_show_tips_com() {
      return this.$store.state.shou_tips_com
    },


  },
  created() {

    // this.sampleUserList = JSON.parse(localStorage.getItem("sampleUserListSd") || "[]")
    this.arrange = this.$route.query.arrange
    this.relation = this.$route.query.relation

    this.mj_tool = this.toolList[this.relation].list[this.arrange - 1].mj_tool

    this.fetchDataList()
    this.fettchSampleList()


  },
  methods: {
    testScroll() {
      // console.log('滚动');
      utils.setScrollDoc(null, 260, 20)

    },
    tozanFn(data, ind) {
      console.log('阳历点赞', data)
      console.log('阳历点赞', ind)
      this.$http.put(`/front/aimj/mjtools/sample/`, {id: data.id}).then(res => {
        console.log(111)
        console.log(res)
        if (res.status == 200) {
          data.vote++
          data.is_vote = 1
          const clickedItem = this.sampleSysList[ind];
          this.sampleSysList.splice(ind, 1); // 删除原位置的元素
          this.sampleSysList.unshift(clickedItem); // 插入到数组开头
        }

      }).catch((err) => {
        console.log('走错误');
        if (!this.isLogin) {
          // this.imgDialogVisible = false
          this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
            confirmButtonText: '立即登录',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.$store.commit('setShowLogin', true)
          }).catch(() => {
          });
          return false;
        } else {

        }
      })

    },
    drow_mask(data) {
      console.log('传出的遮罩层');

      console.log(data);

    },

    fettchSampleList() {

      const year = this.currentTimer.getFullYear();
      const month = String(this.currentTimer.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
      const day = String(this.currentTimer.getDate()).padStart(2, '0');
      const hours = String(this.currentTimer.getHours()).padStart(2, '0');
      const minutes = String(this.currentTimer.getMinutes()).padStart(2, '0');
      const seconds = String(this.currentTimer.getSeconds()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      console.log('this.toolList[]', this.mj_tool)
      this.$http.get('/front/aimj/mjtools/sample/', {
        params: {
          mj_tool: this.mj_tool,
          page: 1,
          size: this.$route.query.relation == 3 ? 20 : 5,
        }
      }).then((res) => {
        console.log('/mjtools/sample/', res)

        if (res.status == 200) {
          this.sampleSysList = res.data
        }
      }).finally(() => {

      })
      return
      if (this.sampleUserList.length > 0) {
        console.log('大于0')
        this.sampleSysList = this.sampleUserList
      } else {
        // this.sampleSysList =res.data
        let num = this.toolList[this.relation].list[this.arrange - 1].mj_tool != HeadExtraction ? 5 : 4
        console.log('不大于0')
        if (
            (localStorage.getItem('zanyangListtxtq') && this.arrange == 1 && this.relation == 2) ||
            (localStorage.getItem('zanyangListwsfd') && this.arrange == 1 && this.relation == 0) ||
            (localStorage.getItem('zanyangListtxcc') && this.arrange == 2 && this.relation == 0) ||
            (localStorage.getItem('zanyangListhbtx') && this.arrange == 3 && this.relation == 0) ||
            (localStorage.getItem('zanyangListqxd') && this.arrange == 4 && this.relation == 0) ||
            (localStorage.getItem('zanyangListhfg') && this.arrange == 5 && this.relation == 0) ||
            (localStorage.getItem('zanyangListbjyc') && this.arrange == 1 && this.relation == 1) ||
            (localStorage.getItem('zanyangListsy') && this.arrange == 2 && this.relation == 1)) {
          if (this.arrange == 1 && this.relation == 2) {//头像提取
            this.$nextTick(() => {
              this.sampleSysList = JSON.parse(localStorage.getItem('zanyangListtxtq'))
            })
          } else if (this.arrange == 1 && this.relation == 0) {//无损放大
            this.$nextTick(() => {
              this.sampleSysList = JSON.parse(localStorage.getItem('zanyangListwsfd'))
            })
          } else if (this.arrange == 2 && this.relation == 0) {//图像擦除
            this.$nextTick(() => {
              this.sampleSysList = JSON.parse(localStorage.getItem('zanyangListtxcc'))
            })
          } else if (this.arrange == 3 && this.relation == 0) {//黑白图像上色
            this.$nextTick(() => {
              this.sampleSysList = JSON.parse(localStorage.getItem('zanyangListhbtx'))
            })
          } else if (this.arrange == 4 && this.relation == 0) {//图像清晰度增强
            this.$nextTick(() => {
              this.sampleSysList = JSON.parse(localStorage.getItem('zanyangListqxd'))
            })

          } else if (this.arrange == 5 && this.relation == 0) {//风格转换
            this.$nextTick(() => {

              this.sampleSysList = JSON.parse(localStorage.getItem('zanyangListhfg'))
            })
          } else if (this.arrange == 1 && this.relation == 1) {//背景移除
            this.$nextTick(() => {

              this.sampleSysList = JSON.parse(localStorage.getItem('zanyangListbjyc'))
            })

          } else if (this.arrange == 2 && this.relation == 1) {//试衣
            this.$nextTick(() => {

              this.sampleSysList = JSON.parse(localStorage.getItem('zanyangListsy'))
            })

          }
        } else {
          for (let i = 0; i < num; i++) {
            console.log(i)
            let obj = {
              add_time: formattedDate,
              img_url: require('./img/aiTool/Upscaler/' + this.toolList[this.relation].list[this.arrange - 1].mj_tool + '0' + (i + 1) + '.png'),
              is_vote: false,
              votes: 0,
              draw_id: i
            }
            this.sampleSysList.splice(i, 0, obj)
          }
        }
        console.log('知道的', ...this.sampleSysList);
      }
    },

    sampleDeleteDraw(item, index) {
      // 样例图片 删除
      this.$confirm('样例不可删除！', '提示', {
        type: 'warning'
      }).then(() => {
      })
    },


    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },


    loadMore(num) {
      console.log('查询2222')
      console.log(num)
      console.log('加载更多')
      // 加载更多数据
      this.noMore = true
      this.loading = true
      if (this.isLogin) {
        console.log('登录请求------')
        // 登录请求样例
        this.fetchDataList()
      } else {
        console.log('未--登录请求------')
        // 未登录请求样例
        // this.pageType = false
        if (this.pageType) {
          // this.pageType = false
          if (this.page >= 3) {
            console.log('已经加载完成')
            this.$message.warning('样例已全部加载')
            return
          }
          this.page = this.page + 1
          this.fettchSampleList()
        }
      }
    },
    fetchDataList() {
      console.log('查询11')
      // 对话内容
      this.loading = true
      this.$http.get('/front/aimj/mjtools/', {
        params: {
          mj_tool: this.mj_tool,
          max_mj_id: this.max_mj_id
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.item_list.length > 0) {
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {

                if (e.status <= 1 || (e.status == 2 && e.local_img_url == "")) {
                  this.checkIds.push(e.draw_id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].draw_id
            this.draw_list = this.draw_list.concat(res.data.item_list)
            // this.draw_list[0].status = 3
            // this.draw_list[0].show_error = 1
            this.draw_list.forEach(item => {
              item.img_url2 = ''
            })
          } else {
            this.noMore = true
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    fetchMsg() {
      let _this = this
      console.log("this.checkIds.length=", this.checkIds.length)
      if (this.checkIds.length == 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.$http.post('/front/aimj/mjtools/status/', {ids: this.checkIds}).then((res) => {
          if (res.status == 200) {
            let item_list = res.data.item_list;
            let draw_id = 0;
            item_list.forEach(e => {
              if (e.img_type == 'imgVirtualTryOn') {
                if (e.fail_reason == 'NO_PERSON' || e.fail_reason == 'NO_UPPER') {
                  this.$message({
                    type: 'warning',
                    message: "模特图片不符合要求，请按照示例上传",
                  })
                  clearInterval(_this.timer);
                }
              }
              draw_id = e.draw_id
              let item = this.draw_list.filter((obj) => obj.draw_id == draw_id)[0];

              item.status = e.status
              item.progress = e.progress;
              item.s_w = e.s_w
              item.s_h = e.s_h
              item.parameters = e.parameters
              if (e.status > 2) {
                // 删除生成成功或失败的
                console.log("删除生成成功或失败的", e)
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
              }
              if (e.img_type == "imgVirtualTryOn" && e.status == 2) {
                item.img_type = 'imgVirtualTryOn'
                item.iw_url = e.iw_url
                item.img_url = e.img_url
                // item.iw_urls = e.iw_urls
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                // this.scrollToTop();
              }
              if (e.status == 2 && (e.local_img_url != "" || e.raw_img_url)) {
                // 生成成功 并下载本地
                console.log("生成成功 并下载本地", e)
                item.img_url = e.img_url
                item.raw_img_url = e.raw_img_url
                item.iw_small_url = e.iw_small_url
                item.iw_url = e.iw_url
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                this.scrollToTop();
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status == 3) {
                // 绘画失败
              }
            })
          }
          if (this.checkIds.length == 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          console.log("res==", res)
          clearInterval(this.timer);
        })
      }, 5000)
    },

    getProfile() {
      this.$http.get(`/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
        }
      }).finally(() => {
      })
    },
    // 获取form信息
    getForm() {
      const refs = [
        'lossless', 'imgremoval',
        'bestquality', 'sharpness',
        'painting', 'bgremoval',
        'tryonclothes', 'headextraction',
        'characterAnime', 'oneClickBeautyTransformation',
        'emitFacefilter', 'emitBlurredfaces', 'emitHairstyleeditor',
        'emitEmotioneditor', 'emitFaceattributeediting', 'emitFacebeauty',
        'emitFacemakeup', 'emitLipscolorchanger', 'emitEnhanceface',
      ];
      const firstDefinedRef = refs.find(ref => this.$refs[ref] !== undefined);
      console.log(firstDefinedRef);

      if (firstDefinedRef) {
        // 使用 this.$refs[firstDefinedRef]
        this.form.data = this.$refs[firstDefinedRef].form
        console.log('获取到的form', this.form.data);

        this.form.mj_tool = this.mj_tool
        if (firstDefinedRef == 'tryonclothes') {
          if (this.form.data.iw_url === '') {
            this.$message.warning('请上传模特图片')
            return false;
          }
          if (this.form.data.iw_urls === '') {
            this.$message.warning('请上传衣装图片')
            return false;
          }
        }
        if (this.form.data.image === '' || this.form.data.iw_url === '') {
          this.$message.warning('请上传图片')
          return false;
        }

      } else {
        // 所有的 ref 都是 undefined
        console.log('this.$refs[firstDefinedRef]系统错误');
      }
      return true;

    },
    //发送消息
    sendMsg() {

      // 登录状态
      if (!this.checkLogin()) return
      if(SITE_BTN_CONFIG.btn_aitool_create.btn_state==0){
        if(this.userInfo.is_vip==0){
          utils.createErrTip('no_open_vip')
        }else{
          if(this.userInfo.is_vip_end==1){
            utils.createErrTip('vip_expire')
          }else{
            this.$store.commit('setTechnical_Show',true)
          }
        }
        return;
      }

      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      if (!this.getForm()) {
        console.log('判断from参数')
        return
      }
      // 同步请求
      this.submitQuestion(this.form);
    },
    submitQuestion(data) {
      // console.log('提交',data)
      // return
      this.sending = true
      this.draw_list.unshift(
          {
            id: 0,
            img_url: 0,
            status: 0,
          })
      this.scrollToTop();
      // 提交问题
      this.$http.post(`/front/aimj/mjtools/`, data).then((res) => {
        console.log('提交成功')
        console.log(res)
        // 获取用户信息
        this.getProfile()
        if (res.status == 200) {
          this.sending = false
          this.draw_list.splice(0, 1, res.data.draw)
          this.scrollToTop();
          // 发送消息
          this.checkIds.push(res.data.draw.draw_id)

          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });

          this.fetchMsg();
        } else {
        }
      }).catch(res => {
        let message = res.message;
        this.draw_list.splice(0, 1)
        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
      this.$store.commit('setisPayPopShow', true)

          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
      this.$store.commit('setisPayPopShow', true)

          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          // 队列已满
          this.$confirm(res.data.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
      this.$store.commit('setisPayPopShow', true)

          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning'
        }).then(() => {
        })

      }).finally(() => {
        this.sending = false;
      })
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    delete_draw_list(id, index) {
      // 删除
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aimj/mjtools/${id}/`, {}
        ).then((res) => {
          this.draw_list.splice(index, 1)
        })
      }).catch((err) => {

      })

    },
    showDefeatPopup(name) {
      // this.$refs.defeatPopup.show();
      if (name === 'showDefeat') {
        this.$refs.conditionPopup.show();
      } else if (name === 'loraStyle') {
        this.$refs.loraStyle.show();
      } else {
        this.$refs.defeatPopup.show();
      }
    },
    defeatPopClose() {
      this.$refs.defeatPopup.close();
    },
    clickImage(downId,position) {
      console.log('下载')
      // 下载图片
      this.$nextTick(() => {
        const wrapper = document.querySelector('.el-image-viewer__actions__inner');
        if (!wrapper) return;
        if (wrapper.querySelector('.my-download-btn')) return;

        const downBtn = document.createElement('i');
        downBtn.setAttribute('class', 'el-icon-download my-download-btn');
        // 绑定点击事件
        downBtn.addEventListener('click', async () => {
          if (!this.checkLogin()){

            return // 登录拦截
          }
          if (position=='sample'){
            this.$message.warning('当前样例不可下载，请生成后重试！')
            return // 样例拦截
          }
          this.$http.get(`/front/aimj/draw/down/${downId}/?${position!=undefined?'nano_position='+position:''}`).then(res => {
            // 假设你用的是 axios 封装，res.data 才是后端 JSON
            if(res.status==200){
              window.location.href = res.data.url
            }else{
              console.log('不是200')
              let message = res.message
              utils.createErrTip(message)
            }
          }).catch(err => {
            console.error('下载失败', err);
            this.$message.warning(err.message)
          });

        });
        wrapper.appendChild(downBtn);
      });
    },
    ImageJump(imgurl,) {
      console.log('111',imgurl);
      window.open(imgurl, '_blank');
    },
    downloadVideo(is_item,index ) {
      if (!this.checkLogin()) {
        return
      }
      this.$http.get(`/front/aimj/draw/down/${is_item.draw_id}/`,).then(res => {
        if (res.status == '200') {
          console.log( res.data.url)
          window.location.href = res.data.url
        }else{
          console.log(1111)
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(err=>{
        console.log('失败')
        console.log(err)
        let message = err.message;
        utils.createErrTip(message)
      }).finally(() => {
        this.loading = false
      })
    },

  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@keyframes scale-breathe {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}


.mj_page {
  width: 100%;
  height: 100%;
  background: #2b2d31;
  border-radius: 10px;
  display: flex;
  //align-items: center;
  //justify-content: center;
}

.left_area {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .createButton {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 15px 0;
    border-top: 1px solid #36373d;
    z-index: 1;
    background: #2b2d31;

    .createBtn{
        font-size: 16px;
        cursor: pointer;
        background-color: #5865f2;
        color: #fff;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 60px;

        span {
          font-size: 12px;
        }
    }
    .screen{
      color:#666;
      text-align: center;
      margin: 10px 0 0;
      font-size: 12px;
    }


  }

  .left_top {
    padding: 10px;
    height: calc(100% - 102px);
    //overflow-y: auto;
    .goBack {
      margin: 5px 0 15px 0;
      font-size: 14px;
      color: #fff;
      display: flex;

      .iconFont {
        display: flex;
        margin-right: 20px;

        div {
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
          width: 16px;
          margin-right: 5px;

          img {
            width: 100%;
            //height: 100%;
            vertical-align: top;
            opacity: 1;
          }
        }
      }

      .font_title {
        font-weight: 700;
      }

    }

    .top_img {
      width: 100%;
      border-radius: 10px;
      overflow: hidden;

      img {
        aspect-ratio: auto 16 / 9;
        width: 100%;
        vertical-align: middle;
        object-fit: cover;
        -webkit-user-drag: none;
      }
    }
  }

  .left_nav {
    padding: 4px 0;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #36373d;
    display: flex;
    align-items: center;

    color: #fff;

    div {
      flex: 1;
      text-align: center;
      margin: 0 4px;
      cursor: pointer;
    }

    .navSelected {
      background-color: #5865f2;
      border-radius: 4px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }

  .scrollable-content {
    overflow-y: auto;
    height: calc(100% - 50px);
    margin: 10px 0;
    color: #fff;
    padding: 0 5px 0 0;

    .toolsIntroduce {
      background-color: #1e1f22;
      padding: 16px 14px;
      display: flex;
      border-radius: 5px;

      .left {
        margin-right: 12px;
        width: 20px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .right {
        flex: 1;


        div {
          font-size: 14px;
          font-weight: 700;
          height: 20px;
          margin-bottom: 5px;
        }

        span {
          font-size: 12px;
          line-height: 20px;
        }

      }
    }

    .describe {
      .refer_title {
        height: 18px;
        margin: 15px 0;
        display: flex;
        align-items: center;
        font-size: 14px;

        div {
          height: 100%;
          border: 2px solid #5865f2;
          border-radius: 2px;
          margin-right: 5px;
        }
      }

      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;

        .upload-demo {
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 269px;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }

        }
      }
    }
  }
}

.draw_area {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #313338;

  .draw_area_tips {
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid #26282c;
    display: flex;
    align-items: center;

    .one {
      font-size: 18px;
      color: #949ba4;
    }

    .two {
      font-size: 16px;
      color: #fff;
      margin: 0 10px;
    }

    .three {
      font-size: 12px;
      color: #f0b132;
    }
  }

  .draw_scroll {
    padding-top: 10px;

    flex: 1;
    position: relative;
    z-index: 9;
    overflow-y: auto;

    .draw_list {
      padding-right: 12px;
      position: relative;
      z-index: 2;

      .draw_list_item {
        padding: 16px 16px 25px;
        background: rgba(152, 121, 69, 0.13);
        border-left: 2px solid #f0b132;
        border-radius: 2px;
        margin-bottom: 15px;

        .avatar {
          width: 48px;
          height: 48px;
          margin-right: 20px;
          background-color: #fff;
          border-radius: 9999px;

          display: flex;
          align-items: center;
          justify-content: center;
        }

        .text {
          flex: 1;

          .title {
            border-bottom: 1px solid #555041;
            padding-bottom: 15px;
            margin-bottom: 20px;

            .info {
              .name {
                font-size: 16px;
                color: #fff;
              }

              .tag {
                line-height: 24px;
                background-color: #5865f280;
                color: #fff;
                font-size: 12px;
                padding: 0 7px;
                border-radius: 4px;
                margin: 0 10px;
              }

              .time {
                color: #707070;
              }
            }

            .delete {
              cursor: pointer;
              margin-left: 8px;

              img {
                width: 20px;
                height: 20px;
                opacity: 0.5;
                margin-right: 3px;

                &.share {
                  width: 16px;
                  height: 16px;
                }
              }

              &:hover {
                color: #fff;

                img {
                  opacity: 1;
                }
              }
            }
          }

          .desc {
            margin: 10px 0;

            p {
              font-size: 14px;
              color: #fff;
              //display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              -webkit-line-clamp: 3;
              padding: 10px 0;
            }

            .en {
              color: #999168;
              border-top: 1px solid #555041;
            }
          }
        }

        .tryonImg {
          width: 630px;
          height: 267px;
          display: flex;
          align-items: center;
          background: rgb(43, 45, 49);

          .modelImg {
            width: 162px;
            height: 216px;
            border-radius: 8px;
            margin: 0 14px;

            .el-image {
              width: 162px;
              height: 216px;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }

          .addImg {
            width: 30px;
            height: 30px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .big_img {
          display: flex;
          position: relative;

          img {
            max-height: 400px;
          }

          .tozan {
            -webkit-user-select: none;
            /* Safari */
            -moz-user-select: none;
            /* Firefox */
            -ms-user-select: none;
            /* IE10+/Edge */
            user-select: none;
            display: flex;
            flex-direction: column;
            align-items: end;
            position: absolute;
            right: 20px;
            top: 10px;

            .zanOne {
              width: 90px;
              height: 30px;
              display: inline-flex;
              line-height: 30px;
              background-color: #ffffff;
              /* 背景颜色 */
              color: #000;
              /* 文字颜色 */
              border: none;
              border-radius: 3px;
              /* 圆角 */
              font-size: 14px;
              cursor: pointer;
              box-shadow: 0 0 8px rgba(255, 255, 255, .1), 0 0 10px rgba(255, 255, 255, .2), 0 0 10px rgba(255, 255, 255, .5);

              /* 荧光效果 */
              .zanImg {
                width: 18px;
                height: 18px;
                margin: 0 10px;
                font-size: 0;
                margin-top: 5px;
              }
            }

            .zanTex {
              font-size: 14px;
              color: #99916b;
              margin: 15px 0;
            }

            .zanTwo {
              color: #f0b53e;
              /* 文字颜色 */
              box-shadow: 0 0 8px rgba(241, 170, 38, 0.1), 0 0 10px rgba(248, 163, 53, 0.2), 0 0 10px rgba(255, 255, 255, .5);
              /* 荧光效果 */
              cursor: auto;
            }
          }

          .big_img_two {

          }

        }

      }
    }
  }

  .btm_area {
    padding: 0 16px;
    height: 85px;
    border-top: 1px solid #26282c;
    position: relative;
    z-index: 19;
  }
}

.fz13 {
  font-size: 13px;
}

.c-fff {
  color: #fff;
}


.con {
  width: 410px;
  height: 560px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;


    .avatar {
      flex-direction: column;
      cursor: pointer;

      .pic {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-bottom: 5px;
        margin-top: 5px;
      }

      .text {
        font-size: 14px;
        color: #fff;

        img {
          width: 14px;
          height: 14px;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .info_list {
      padding: 15px 18px;

      .info_list_title {
        font-size: 14px;
        color: #fff;
        margin-left: -16px;
      }

      .info_item {
        padding: 15px 0;
        border-bottom: 1px solid #36373d;

        .title {
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          p {
            font-size: 14px;
            color: #b0b0b0;
          }
        }

        .text {
          font-size: 14px;
          color: #b0b0b0;

          .btn {
            padding: 0 14px;
            display: block;
            line-height: 34px;
            cursor: pointer;
            background-color: #5865f2;
            color: #fff;
            border-radius: 4px;

            &:hover {
              background-color: rgba(88, 101, 242, 0.867);
            }
          }
        }
      }
    }
  }
}


.create_error {
  width: 190px;
  //height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding: 28px 0 15px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 64px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
  .error_text4 {
    font-size: 12px;
    color: #ccc;
    line-height: 1.8;
    margin-top: 10px;

    a {
      color: red;
    }
  }
}

.defeat_popup {
  width: 600px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}


.Image_manipulation {
  //width: 500px;
  background-color: #3f3c3a;
  padding: 20px 20px;
  border-radius: 4px;
  position: relative;

  .clear {
    position: absolute;
    top: 0px;
    right: 0px;
    //background-color: #5865f2;
    border: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-icon-error {
      font-size: 20px;
      color: #565658;
    }
  }

  .clear:hover {
    background-color: #343538;
  }
}

.msg-item-content {
  font-size: 13px;
  line-height: 20px;
  padding-top: 5px;

  &.detail_loading {
    .remove_icon {
      // display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("./img/update_close.png");
      background-color: rgba(100, 100, 100, 0.6);
      cursor: pointer;
      border-radius: 3px;
    }

    .loading_text {
      padding-left: 12px;
      color: #f0b132;
    }
  }
}

.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

.arrow_icon {
  width: 3px;
  background-color: #fff;
  position: relative;
  display: flex;

  div {
    position: absolute;
    z-index: 1;
    padding: 4px;
    background-color: #fff;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.arrow_icon2 {
  width: 3px;
  background-color: #2b2d31;
  position: relative;
  display: flex;

  div {
    position: absolute;
    z-index: 1;
    padding: 4px;
    background-color: #2b2d31;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.msg_img_sample {
  max-width: 600px;
  border-radius: 7px;
  overflow: hidden;

  img {
    width: 100%;
  }
}

.msg_img_width1 {
  width: 100%;
}

.msg_img_width2 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.msg_img_wrap {
  flex: 1;
  max-width: 400px;
  object-fit: contain;
  position: relative;
  overflow: hidden;
  background-image: url('./img/aiTool/img_bg.png');
  //margin-right: 10px;
  // border-radius:5px;
  .look_img {
    display: none;
    //opacity: 0;
    cursor: pointer;
    //width: 100px;
    padding: 0 10px;
    height: 36px;
    position: absolute;
    top: 10px;
    right: 10px;
    border: rgba(88, 101, 242, 0.8) solid 2px;
    background-color: rgba(88, 101, 242, 0.533);
    border-radius: 6px;
    color: white;
    font-size: 14px;
    box-sizing: border-box;
    line-height: 32px;
    text-align: center;
  }

  .left_img {
    position: absolute;
    top: 50px;
    left: 0;
    color: white;
    font-size: 14px;
    background-color: #00000091;
    border-top-right-radius: 100px; /* 右上角半圆 */
    border-bottom-right-radius: 100px; /* 右下角半圆 */
    padding: 7px 10px;

    span {
      margin: 0 5px;
    }

  }

  .right_img {
    position: absolute;
    top: 50px;
    right: 0;
    color: white;
    font-size: 14px;
    background-color: #00000091;
    border-top-left-radius: 100px; /* 右上角半圆 */
    border-bottom-left-radius: 100px; /* 右下角半圆 */
    padding: 7px 10px;

    span {
      margin: 0 5px;
    }

  }

  &:hover {
    .img_footer {
      bottom: 0;
    }
  }

  .msg_img_ele {
    display: block;
    width: 100%;
    cursor: pointer;
  }

  .img_footer {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-around;
    transition: bottom 0.3s;

    .footer_item {
      cursor: pointer;

      .footer_icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
        background-size: 100% 100%;

        &.download {
          background-image: url("./img/download.png");
        }

        &.preview {
          background-image: url("./img/preview_img.png");
        }

        &.delete {
          background-image: url("./img/remove.png");
        }
      }

      span {
        vertical-align: middle;
        display: inline-block;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  // 图片上传
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    padding: 5px 5px;

  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
    width: 100px !important;
    height: 100px !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    text-align: center;
  }

  .avatars {
    width: 100px;
    height: 100px;
    display: block;
    border: 1px dashed #d9d9d9;
  }

}


.msg_img_wrap:hover {
  .look_img {
    display: block;
  }
}
</style>